const auth = {
  email: 'E-mail',
  password: 'Senha',
  welcomeMessage: 'Fazer login na sua conta',

  validations: {
    email: {
      required: 'E-mail é obrigatório',
      email: 'Endereço de e-mail inválido',
      emailReceived: 'O endereço de e-mail que você recebeu do seu administrador',
    },
    password: {
      required: 'Senha é requerido',
      password: 'Senha inválida',
    },
    otp: {
      required: 'É necessário um código de 6 dígitos.',
      invalid: 'O código que você inseriu é inválido.'
    }
  },
  resetPassword: {
    email: 'E-mail não encontrado',
    resetToken: 'O token de redefinição é inválido',
  },
  loginBtn: 'Entrar',
  toast: {
    authFailed: 'E-mail ou senha inválidos',
    unexpectedError: 'Ocorreu um erro inesperado',
    codeInvalid: 'Falha na validação. Por favor, verifique se você inseriu o código correto de 6 dígitos ou solicite um novo.',
    securityUpdate: 'As políticas de segurança foram atualizadas. Estamos atualizando o sistema.',
  },

  toastBlockRequest: {
    body: 'Você foi bloqueado temporariamente devido a um excesso de tentativas malsucedidas. Por favor, tente novamente mais tarde',
  },

  /** 2FA related translations below */
  twoFactorAuthSelectMessage: 'Escolha o método de validação',
  twoFactorAuthVerifyMessage: 'Confirmar este dispositivo',
  twoFactorAuthVerifyLabel: 'Por favor, insira o código de 6 dígitos que acabamos de lhe enviar.',
  sendVerificationCodeBtn: 'Enviar código de validação',
  phoneMethodLabel: 'SMS',
  verifyBtn: 'Enviar',
  resendVerificationCodeBtn: 'Reenviar Código',
  resendVerificationCodeLbl: 'Reenviar código em {{seconds}}s..',
};

export default auth;
